import { ReducerAction } from '../ReducerAction';
import { Pdvinfo } from '../../../domain/models/PdvInfo';
import { ActionType } from '../ActionsTypes';

export class PdvInfoAction {
  static setPdvInfo(pdv: Pdvinfo): ReducerAction {
    return {
      type: ActionType.SET_PDV_INFO,
      payload: pdv
    }
  }
}
